<script setup lang="ts">
import { ref, onMounted, watch } from 'vue'

const props = defineProps<{
  isLoading: boolean
}>()

const progress = ref(0)
const opacity = ref(0)

const startLoading = () => {
  opacity.value = 1
  progress.value = 0
  // Simular progreso incremental
  const interval = setInterval(() => {
    if (progress.value < 90) {
      progress.value += (90 - progress.value) * 0.1
    }
  }, 100)

  return interval
}

const finishLoading = () => {
  progress.value = 100
  setTimeout(() => {
    opacity.value = 0
    progress.value = 0
  }, 200)
}

let loadingInterval: number | null = null

watch(() => props.isLoading, (newValue) => {
  if (newValue) {
    if (loadingInterval) clearInterval(loadingInterval)
    loadingInterval = startLoading()
  } else {
    if (loadingInterval) {
      clearInterval(loadingInterval)
      loadingInterval = null
    }
    finishLoading()
  }
})

onMounted(() => {
  if (props.isLoading) {
    loadingInterval = startLoading()
  }
})
</script>

<template>
  <div 
    class="fixed top-0 left-0 w-full z-[100]"
    :style="{ opacity }"
  >
    <div 
      class="h-[2px] bg-primary-500 shadow-[0_0_8px_rgba(59,130,246,0.7)] dark:shadow-[0_0_8px_rgba(59,130,246,0.9)]"
      :style="{ 
        width: `${progress}%`,
        transition: 'width 0.2s ease-in-out'
      }"
    />
  </div>
</template>

<style scoped>
.h-[2px] {
  transition: width 0.2s ease-in-out;
}
</style>
